import React from 'react'
import { CKEditor } from '@ckeditor/ckeditor5-react'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import './index.scss'

const Editor = ({ 
  value = '', 
  onChange, 
  placeholder = 'İçerik yazın...',
  minHeight = 200,
  disabled = false,
  config = {}
}) => {
  const defaultConfig = {
    placeholder,
    toolbar: {
      items: [
        'heading',
        '|',
        'bold',
        'italic',
        'underline',
        'strikethrough',
        '|',
        'bulletedList',
        'numberedList',
        '|',
        'outdent',
        'indent',
        '|',
        'blockQuote',
        'insertTable',
        '|',
        'link',
        '|',
        'undo',
        'redo'
      ],
      shouldNotGroupWhenFull: true
    },
    heading: {
      options: [
        { model: 'paragraph', title: 'Paragraf', class: 'ck-heading_paragraph' },
        { model: 'heading1', view: 'h1', title: 'Başlık 1', class: 'ck-heading_heading1' },
        { model: 'heading2', view: 'h2', title: 'Başlık 2', class: 'ck-heading_heading2' },
        { model: 'heading3', view: 'h3', title: 'Başlık 3', class: 'ck-heading_heading3' },
        { model: 'heading4', view: 'h4', title: 'Başlık 4', class: 'ck-heading_heading4' }
      ]
    },
    table: {
      contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells']
    },
    language: 'tr',
    ...config
  }

  const handleEditorChange = (event, editor) => {
    const data = editor.getData()
    if (onChange) {
      onChange(data)
    }
  }

  return (
    <div className="editor-wrapper" style={{ '--editor-min-height': `${minHeight}px` }}>
      <CKEditor
        editor={ClassicEditor}
        data={value}
        config={defaultConfig}
        disabled={disabled}
        onChange={handleEditorChange}
        onReady={(editor) => {
          // Editör hazır olduğunda min height ayarla
          const editableElement = editor.editing.view.document.getRoot()
          editor.editing.view.change((writer) => {
            writer.setStyle('min-height', `${minHeight}px`, editableElement)
          })
        }}
      />
    </div>
  )
}

export default Editor

